import '../RadioGroup/radioGroup.scss';

import CssBaseline from '@mui/material/CssBaseline';
import uniqueId from 'lodash/uniqueId';

import { Radio } from '../Radio/Radio';

type RadioGroupLoadingProps = {
  variant?: 'stacked' | 'stacked-compact' | 'inline';
  labelPlacement?: 'beside' | 'below';
  loadingCount: number;
};

export const RadioGroupLoading = ({
  variant = 'stacked',
  labelPlacement = 'beside',
  loadingCount,
}: RadioGroupLoadingProps) => {
  return (
    <CssBaseline>
      <div className={`radio-group ${variant}`} role="radiogroup">
        {[...Array(loadingCount)].map(() => (
          <Radio
            key={uniqueId('loading-')}
            label=""
            labelPlacement={labelPlacement}
            loading
          />
        ))}
      </div>
    </CssBaseline>
  );
};
